// extracted by mini-css-extract-plugin
export default {"Body":"_Body--w595R","BodyText":"_BodyText--bYk0Q","TerminateIcon":"_TerminateIcon--JAQAr"};